import { getTestIds } from 'seagull/utils/TestIds';
export const GetNotificationEditFieldTID = (parentTestId)=>getTestIds(parentTestId);
